import service from '@/utils/service'
import {findIndex} from 'lodash'

const state = {
  admin:false,
  code:null,
  info: {},
  modules: [],
  menus: null,
  servers: {
    'online': [],
    'hefu': [],
  },
  marks: [],
}

const mutations = {
    set_admin(state, admin) {
      state.admin = admin
    },
    set_code (state, code) {
        state.code = code
    },
    set_info (state, info) {
        state.info = info
    },
    clear_info(state) {
        state.info = {}
    },
    set_modules (state, modules) {
        state.modules = modules
    },
    clear_modules(state) {
        state.modules = []
    },
    set_menus (state, menus) {
      state.menus = menus
    },
    clear_menus(state) {
        state.menus = null
    },
    set_servers (state, servers) {
        state.servers = servers
    },
    clear_servers(state) {
        state.servers = {
          'online': [],
          'hefu': [],
        }
    },
    set_marks (state, marks) {
      state.marks = marks
    },
    clear_marks (state) {
      state.marks = []
    },
    add_mark(state, mark) {
      if(mark.project_id==state.code) {
        state.marks.push(mark)
      }
    },
    update_mark(state, mark) {
      let index = findIndex(state.marks, {id:mark.id})
      if(index>=0) {
        state.marks.splice(index, 1, mark)
      }
    },
    delete_mark(state, id) {
      let index = findIndex(state.marks, {id:id})
      if(index>=0) {
        state.marks.splice(index, 1)
      }
    }
  }

  const actions = {
    new_init_game(context) {
      // context.commit("clear_projects");
      context.commit("clear_info");
      context.commit("clear_modules");
      context.commit("clear_servers");
      context.commit("clear_menus");
      context.commit("clear_marks");
      // let total_info = service.getData(service.api.project.total_info)
      // let projects = service.getData(service.api.common.project)
      
      return service.getData(service.api.project.total_info).then((datas) => {
        context.commit("set_info", datas.info);
        context.commit("set_modules", datas.modules);
        context.commit("set_servers", datas.servers);
        context.commit("set_menus", datas.menus);
        context.commit("set_marks", datas.marks);

        // context.commit("set_projects", datas[1])
      }).catch((errors)=>{
        console.log(errors)
        return new Promise((resolve, reject) => {
          reject(errors) 
        })
      })
    },
    init_game(context) {
      context.commit("clear_info");
      context.commit("clear_modules");
      context.commit("clear_menus");
      context.commit("clear_servers");
      let info = service.getData(service.api.project.info)
      let pmodule = service.getData(service.api.project.module)
      let server = service.getData(service.api.project.server)
      let projects = service.getData(service.api.common.project)
      
      return Promise.all([info, pmodule, server, projects]).then((datas) => {
        context.commit("set_info", datas[0]);
        context.commit("set_modules", datas[1]);
        context.commit("set_servers", datas[2]);
        context.commit("set_projects", datas[3])
      }).catch((errors)=>{
        return new Promise((resolve, reject) => {
          reject(errors) 
        })
      })
    },
    async get_modules(context) {
      context.commit("clear_modules");
      await service.getData(service.api.project.module).then((data)=>{
        context.commit("set_modules", data);
      })
    },
    get_menus(context) {
      context.commit("clear_menus");
      service.getData(service.api.project.menu).then((data)=>{
        context.commit("set_menus", data);
      })
    },
    async get_servers(context) {
      context.commit("clear_servers");
      await service.getData(service.api.project.server).then((data)=>{
        context.commit("set_servers", data);
      })
    },
    get_marks(context) {
      context.commit("clear_marks");
      service.getData(service.api.project.mark).then((data)=>{
        context.commit("set_marks", data);
      })
    }
  }

  const getters = {
    getModule:(state) => (id) => {
      return state.modules.find(m => m.id === id)
    },
    getMarks:(state) => (id) => {
      let marks = []
      state.marks.forEach((mark)=>{
        if(mark.is_all===true || mark.sub_module===id) {
          marks.push(mark)
        }
      });
      return marks
    },
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }